import {
  ASSIGN_PERMISSION_REQUEST,
  ASSIGN_PERMISSION_SUCCESS,
  ASSIGN_PERMISSION_FAILURE,
  FETCH_ROLE_PERMISSIONS_REQUEST,
  FETCH_ROLE_PERMISSIONS_SUCCESS,
  FETCH_ROLE_PERMISSIONS_FAILURE,
} from "../../../actions/role-management/assignPermission/assignPermissionActions";

const initialState = {
  loading: false,
  rolePermissions: [],
  error: null,
};

const assignPermissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_PERMISSION_REQUEST:
    case FETCH_ROLE_PERMISSIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case ASSIGN_PERMISSION_SUCCESS:
      return { ...state, loading: false, error: null };

    case FETCH_ROLE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        rolePermissions: action.payload,
        error: null,
      };

    case ASSIGN_PERMISSION_FAILURE:
    case FETCH_ROLE_PERMISSIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default assignPermissionReducer;
